"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrackEnabled = exports.isScreenTrack = exports.isScreenSharingStream = exports.isCameraTrack = exports.isCameraStream = exports.getTracks = exports.getTrackLabel = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getTrackLabel = track => {
  var _track$getSettings;
  var settings = track === null || track === void 0 || (_track$getSettings = track.getSettings) === null || _track$getSettings === void 0 ? void 0 : _track$getSettings.call(track);
  return (settings === null || settings === void 0 ? void 0 : settings.deviceId) + ' - ' + (track === null || track === void 0 ? void 0 : track.label);
};
exports.getTrackLabel = getTrackLabel;
var getTracks = (stream, kind) => {
  if (!(stream !== null && stream !== void 0 && stream.getTracks)) return [];
  if (kind.toLowerCase() === 'screen' && stream.getVideoTracks) {
    return getScreenTracks(stream.getVideoTracks());
  }
  if (kind.toLowerCase() === 'camera' && stream.getVideoTracks) {
    return getCameraTracks(stream.getVideoTracks());
  }
  if (kind.toLowerCase() === 'video' && stream.getVideoTracks) {
    return stream.getVideoTracks();
  }
  if (kind.toLowerCase() === 'audio' && stream.getAudioTracks) {
    return stream.getAudioTracks();
  }
  return stream.getTracks().filter(t => t.kind === kind);
};
exports.getTracks = getTracks;
var isCameraStream = s => {
  if (s && s.getVideoTracks) {
    var _getCameraTracks;
    return !!((_getCameraTracks = getCameraTracks(s.getVideoTracks())) !== null && _getCameraTracks !== void 0 && _getCameraTracks.length);
  }
  return false;
};
exports.isCameraStream = isCameraStream;
var isScreenTrack = track => {
  var _track$getSettings2, _track$getConstraints;
  var settings = track === null || track === void 0 || (_track$getSettings2 = track.getSettings) === null || _track$getSettings2 === void 0 ? void 0 : _track$getSettings2.call(track);
  var constraints = track === null || track === void 0 || (_track$getConstraints = track.getConstraints) === null || _track$getConstraints === void 0 ? void 0 : _track$getConstraints.call(track);
  if (settings) {
    var _navigator;
    return !!((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator = _navigator.mediaDevices) !== null && _navigator !== void 0 && _navigator.getDisplayMedia) && (settings.displaySurface === 'monitor' ||
    // Full screen sharing
    settings.displaySurface === 'window' ||
    // Window sharing
    settings.displaySurface === 'browser' ||
    // Browser tab sharing
    (constraints === null || constraints === void 0 ? void 0 : constraints.mediaSource) === 'screen' ||
    // Firefox
    (constraints === null || constraints === void 0 ? void 0 : constraints.mediaSource) === 'window' ||
    // Firefox
    (constraints === null || constraints === void 0 ? void 0 : constraints.mediaSource) === 'monitor' ||
    // Firefox
    settings.deviceId && settings.deviceId.indexOf('screen:') !== -1) // Chrome & Edge
    ;
  }

  return false;
};
exports.isScreenTrack = isScreenTrack;
var isCameraTrack = track => !isScreenTrack(track);
exports.isCameraTrack = isCameraTrack;
var getScreenTracks = tracks => {
  if (tracks) {
    return tracks.filter(isScreenTrack);
  }
  return [];
};
var getCameraTracks = tracks => {
  if (tracks) {
    return tracks.filter(isCameraTrack);
  }
  return [];
};
var isScreenSharingStream = s => {
  if (s && s.getVideoTracks) {
    var _getScreenTracks;
    return !!((_getScreenTracks = getScreenTracks(s.getVideoTracks())) !== null && _getScreenTracks !== void 0 && _getScreenTracks.length);
  }
  return false;
};
exports.isScreenSharingStream = isScreenSharingStream;
var isTrackEnabled = exports.isTrackEnabled = function isTrackEnabled(track) {
  var mutedCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!track) return false;
  if ((0, _isNil.default)(track._enabled)) {
    if (mutedCheck) return track.enabled && !track.muted;
    return track.enabled;
  }
  if (mutedCheck) return !!track._enabled && !track.muted;
  return !!track._enabled;
};